import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { AndresB_Video5 } from '../../../../../utils/EN/Modals/aiArtists';

const ModalVideoAndres5 = () => {
  return (
    <>
      <ModalVideo
        id="andres-video-5"
        dataText={AndresB_Video5}
        videoSrc="https://player.vimeo.com/video/1208475847?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_AI_ANDRES_VIDEO_5"
      />
    </>
  );
};

export default ModalVideoAndres5;
